import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Directive for custom cell templates in schedule-grid.
 * Usage: <ng-template appScheduleGridCell="blockContent" let-block let-row="row" let-date="date">
 *
 * Supported template names:
 * - 'blockContent': Custom rendering of a schedule block
 * - 'emptyCell': Custom rendering of an empty cell (no blocks)
 * - 'rowLabel': Custom rendering of the row label column
 */
@Directive({
  selector: 'ng-template[appScheduleGridCell]',
  standalone: true,
})
export class ScheduleGridCellDirective {
  @Input('appScheduleGridCell') name!: string;
  constructor(public template: TemplateRef<any>) {}
}
